<template>
  <div class="line-info-list-pagination">
    <span class="mr-4 grey--text">Página {{ page }} de {{ numberOfPages }}</span>
    <div class="mr-4">
      <v-btn small dark icon color="bluePcm" @click="firstPage">
        <v-icon>mdi-chevron-double-left</v-icon>
      </v-btn>
      <v-btn icon small dark color="bluePcm" @click="formerPage">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-btn icon dark small color="bluePcm" @click="nextPage">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
      <v-btn dark small icon color="bluePcm" @click="lastPage">
        <v-icon>mdi-chevron-double-right</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    page: Number,
    numberOfPages: Number,
  },
  methods: {
    firstPage() {
      this.$emit('firstPage')
    },
    formerPage() {
      this.$emit('formerPage')
    },
    nextPage() {
      this.$emit('nextPage')
    },
    lastPage() {
      this.$emit('lastPage')
    },
  },
}
</script>

<style scoped>
.line-info-list-pagination {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>
